import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "question col-3 d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingleValue = _resolveComponent("SingleValue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SingleValue, {
      value: _ctx.blankField === 'lhs' ? undefined : _ctx.leftValue
    }, null, 8, ["value"]),
    _createElementVNode("div", null, _toDisplayString(_ctx.operation), 1),
    _createVNode(_component_SingleValue, {
      value: _ctx.blankField === 'rhs' ? undefined : _ctx.rightValue
    }, null, 8, ["value"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", null, "=", -1)),
    _createVNode(_component_SingleValue, {
      value: _ctx.blankField === 'result' ? undefined : _ctx.result
    }, null, 8, ["value"])
  ]))
}